(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".block-slider").forEach(slider => {

    const track = slider.querySelector(".block-slider-track");
    const slides = slider.querySelectorAll(".block-slide");

    if (!track || slides.length === 0) return;

    let index = 0;

    slider.querySelector(".slider-next").onclick = () => {
      index = (index + 1) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
    };

    slider.querySelector(".slider-prev").onclick = () => {
      index = (index - 1 + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
    };

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jps-final-cta"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jps-final-cta')) {
 customElements.define('jps-final-cta', class extends HTMLElement {
  connectedCallback() {
   if (this.ready || !this.hasAttribute('data-return-to-selector')) return;
   this.ready = true;
   this.querySelector('a').addEventListener('click', event => {
    const hero = document.querySelector('.jps-hero');
    if (!hero) return;
    const selector = hero.querySelector('.jps-packs, .jps-details') || hero;
    const headers = document.querySelectorAll('sticky-header, #shopify-section-header, .shopify-section-group-header-group');
    let offset = 16;
    headers.forEach(header => {
     const rect = header.getBoundingClientRect();
     if (rect.top <= 1 && rect.bottom > 0 && rect.height < window.innerHeight / 2) offset = Math.max(offset, rect.bottom + 16);
    });
    event.preventDefault();
    window.scrollTo({top:Math.max(0, window.scrollY + selector.getBoundingClientRect().top - offset), behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    selector.setAttribute('tabindex', '-1');
    selector.focus({preventScroll:true});
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jps-oil-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jps-oil-faq')) {

 customElements.define('jps-oil-faq', class extends HTMLElement {

  connectedCallback() {

   if (this.ready) return;

   this.ready = true;

   this.animations = new Map();

   this.items = Array.from(this.querySelectorAll('details'));

   this.items.forEach((item, index) => {

    item.open = index === 0 && this.hasAttribute('data-open-first');

    item.querySelector('summary').addEventListener('click', event => {

     event.preventDefault();

     const opening = !item.open || item.hasAttribute('data-closing');

     if (opening) this.items.forEach(other => { if (other !== item && other.open) this.toggleItem(other, false); });

     this.toggleItem(item, opening);

    });

   });

  }

  toggleItem(item, opening) {

   const start = item.getBoundingClientRect().height;

   const previous = this.animations.get(item);

   if (previous) previous.cancel();

   item.style.height = '';

   item.open = true;

   item.toggleAttribute('data-closing', !opening);

   const end = opening ? item.getBoundingClientRect().height : item.querySelector('summary').getBoundingClientRect().height;

   if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !item.animate) {

    item.open = opening;

    item.removeAttribute('data-closing');

    return;

   }

   const animation = item.animate([{height: start + 'px'}, {height: end + 'px'}], {duration: 280, easing: 'cubic-bezier(.22,1,.36,1)'});

   this.animations.set(item, animation);

   animation.onfinish = () => {

    item.open = opening;

    item.removeAttribute('data-closing');

    this.animations.delete(item);

   };

  }

  disconnectedCallback() {

   if (this.animations) this.animations.forEach(animation => animation.cancel());

  }

 });

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jps-product-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{
  function mount(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    const data=JSON.parse(root.querySelector('[data-jps-data]').textContent);
    const slides=root.querySelector('[data-slides]'),thumbs=root.querySelector('[data-thumbs]');
    let index=0;const images=[...slides.querySelectorAll('img')];const originalFirst=images[0]?.cloneNode(true);
    images.forEach((img,i)=>{const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',`Bild ${i+1} anzeigen`);const copy=img.cloneNode(true);copy.removeAttribute('sizes');copy.removeAttribute('srcset');copy.loading='lazy';copy.alt='';button.append(copy);button.addEventListener('click',()=>go(i));thumbs.append(button)});
    const buttons=[...thumbs.children];
    const thumbPrev=root.querySelector('[data-thumb-prev]'),thumbNext=root.querySelector('[data-thumb-next]');
    const thumbNav=root.querySelector('[data-thumb-nav]');
    function refreshThumbNavigation(){
      const end=Math.max(0,thumbs.scrollWidth-thumbs.clientWidth);
      thumbPrev.disabled=thumbs.scrollLeft<2;thumbNext.disabled=thumbs.scrollLeft>=end-2;
      thumbNav.hidden=buttons.length<2;
    }
    function moveThumbs(direction){thumbs.scrollBy({left:direction*Math.max(76,thumbs.clientWidth-76),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})}
    thumbPrev.addEventListener('click',()=>moveThumbs(-1));thumbNext.addEventListener('click',()=>moveThumbs(1));
    thumbs.addEventListener('scroll',refreshThumbNavigation,{passive:true});

    function paint(){buttons.forEach((b,i)=>b.setAttribute('aria-current',String(i===index)))}
    function go(i){index=(i+slides.children.length)%slides.children.length;const thumb=buttons[index];if(thumb){const t=thumb.getBoundingClientRect(),v=thumbs.getBoundingClientRect();if(t.left<v.left||t.right>v.right)thumbs.scrollBy({left:t.left-v.left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})}slides.scrollTo({left:index*slides.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});paint()}
    root.querySelector('[data-prev]').addEventListener('click',()=>go(index-1));root.querySelector('[data-next]').addEventListener('click',()=>go(index+1));
    if(slides.children.length<2){root.querySelector('[data-prev]').hidden=true;root.querySelector('[data-next]').hidden=true}
    slides.addEventListener('scroll',()=>{index=Math.round(slides.scrollLeft/Math.max(1,slides.clientWidth));paint()},{passive:true});paint();
    let active=null,imageRevision=0;
    const quantity=root.querySelector('input[name="quantity"]');
    const formatter=new Intl.NumberFormat('de-DE',{style:'currency',currency:data.currency||'EUR'});
    function syncQuantity(){
      const q=quantity?Math.max(1,Math.min(99,Math.floor(Number(quantity.value)||1))):1;
      if(quantity)quantity.value=q;
      const minus=root.querySelector('[data-quantity-minus]'),plus=root.querySelector('[data-quantity-plus]');
      if(minus)minus.disabled=q<=1;if(plus)plus.disabled=q>=99;
      root.querySelectorAll('[data-progress]').forEach(box=>{
        const threshold=Number(box.dataset.threshold),total=(active?.cents||0)*q;
        const pack=root.querySelector('.jps-packs input[name^="jps-pack-"]:checked')?.value||'single';
        const freeBundle=root.dataset.bundlesFreeShipping==='true'&&pack.startsWith('bundle-');
        const percent=freeBundle?100:Math.max(0,Math.min(100,total/threshold*100));
        const reached=freeBundle||total>=threshold;
        box.querySelector('[data-progress-text]').textContent=freeBundle?'Dieses Paket liefern wir versandkostenfrei.':reached?box.dataset.reached:box.dataset.pending.replace('{amount}',formatter.format(Math.max(0,threshold-total)/100));
        box.querySelector('[data-progress-fill]').style.width=percent+'%';
        box.querySelector('[role="progressbar"]').setAttribute('aria-valuenow',String(Math.round(percent)));
      });
      const pack=root.querySelector('.jps-packs input[name^="jps-pack-"]:checked')?.value||'single';
      root.querySelectorAll('[data-gift-pack]').forEach(box=>box.hidden=box.dataset.giftPack!==pack);
    }
    async function swapImage(src,alt,srcset){
      const img=images[0];const revision=++imageRevision;if(img.src===src){img.classList.remove('is-changing');return;}
      const preload=new Image();preload.src=src;
      try{await preload.decode()}catch{return}
      if(revision!==imageRevision||!root.isConnected)return;
      const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
      if(!reduced){img.classList.add('is-changing');await new Promise(resolve=>setTimeout(resolve,200))}
      if(revision!==imageRevision){img.classList.remove('is-changing');return}
      img.removeAttribute('srcset');img.src=src;img.alt=alt||'';if(srcset)img.srcset=srcset;
      const t=buttons[0]?.querySelector('img');if(t){t.src=src;t.removeAttribute('srcset')}
      requestAnimationFrame(()=>img.classList.remove('is-changing'));
    }
    root.querySelector('[data-quantity-minus]')?.addEventListener('click',()=>{quantity.value=Number(quantity.value)-1;syncQuantity();quantity.dispatchEvent(new Event('change',{bubbles:true}))});
    root.querySelector('[data-quantity-plus]')?.addEventListener('click',()=>{quantity.value=Number(quantity.value)+1;syncQuantity();quantity.dispatchEvent(new Event('change',{bubbles:true}))});
    quantity?.addEventListener('change',syncQuantity);
    quantity?.addEventListener('input',()=>{if(quantity.value!=='')syncQuantity()});

    function update(){
      const pack=root.querySelector('.jps-packs input[name^="jps-pack-"]:checked')?.value||'single';
      const size=root.querySelector('.jps-sizes input:checked')?.value||root.querySelector('[data-variant-id]')?.value;
      active=pack==='single'?data.single.variants.find(v=>String(v.id)===size):data[pack];
      if(!active)return;
      root.querySelector('[data-sizes]')?.removeAttribute('hidden');
      const set=(selector,value)=>{const e=root.querySelector(selector);if(e)e.textContent=value||''};
      set('[data-price]',active.price);set('[data-compare]',active.compare);set('[data-unit]',active.unit);set('[data-saving]',active.saving?`${active.saving} sparen`:'');
      for(const [s,value]of [['[data-compare]',active.compare],['[data-saving]',active.saving]]){const e=root.querySelector(s);if(e)e.hidden=!value}
      const single=data.single.variants.find(v=>String(v.id)===size);set('[data-single-price]',single?.price);
      const id=root.querySelector('[data-variant-id]');if(id)id.value=active.id;
      const atc=root.querySelector('[data-atc]');if(atc){atc.disabled=!active.available;const label=atc.querySelector('[data-atc-label]');label.dataset.original||=(label.textContent);label.textContent=active.available?label.dataset.original:'Ausverkauft'}
      syncQuantity();
      if(images[0]){
        const custom=pack==='single'&&data.customGallery&&originalFirst;
        const src=custom?originalFirst.src:active.image;
        if(src)swapImage(src,custom?originalFirst.alt:(pack==='single'?data.single.title:data[pack].title),custom?originalFirst.srcset:'');
        go(0);
      }
    }
    root.addEventListener('click',e=>{const label=e.target.closest('.jps-sizes label');if(!label)return;const size=label.querySelector('input');const single=root.querySelector('.jps-packs input[value="single"]');if(size)size.checked=true;if(single)single.checked=true;update()});
    root.addEventListener('change',e=>{if(e.target.matches('.jps-sizes input')){const single=root.querySelector('.jps-packs input[value="single"]');if(single)single.checked=true}if(e.target.matches('.jps-packs input,.jps-sizes input'))update()});
    root.querySelector('form')?.addEventListener('submit',e=>{
      if(!active?.available){e.preventDefault();return}
      // A theme-specific drawer adapter can prevent this event and handle the form.
      // Without an adapter the native Shopify form posts to the cart.
      const hook=new CustomEvent('jps:before-add',{bubbles:true,cancelable:true,detail:{form:e.currentTarget,variantId:active.id,section:root}});
      if(!root.dispatchEvent(hook))e.preventDefault();
    });
    // Viewport pinning avoids overflow and transform traps in theme wrappers.
    const galleryColumn=root.querySelector('.jps-gallery');
    const galleryPanel=root.querySelector('.jps-gallery__sticky');
    const galleryStage=galleryPanel.querySelector('.jps-gallery__stage');
    const lifecycle=new AbortController();
    let portal=null,layoutFrame=0;
    function unpinGallery(){
      if(!portal)return;
      galleryColumn.append(galleryPanel);portal.remove();portal=null;
    }
    function pinGeometry(column, panelHeight, offset){
      return {left:column.left,width:column.width,top:Math.min(offset,column.bottom-panelHeight)};
    }
    function visibleHeaderBottom(){
      const headers=document.querySelectorAll('#shopify-section-header,.shopify-section-group-header-group,sticky-header,.header-wrapper,header[role="banner"],body > header');
      let bottom=0;
      headers.forEach(header=>{
        const rect=header.getBoundingClientRect();
        const css=getComputedStyle(header);
        if(css.display==='none'||css.visibility==='hidden'||Number(css.opacity)===0)return;
        // Reserve only the header actually visible near the viewport's top.
        if(rect.width>0&&rect.height>0&&rect.height<innerHeight/2&&rect.top<120&&rect.bottom>0){bottom=Math.max(bottom,rect.bottom)}
      });
      return Math.max(0,bottom);
    }
    function updateGalleryPosition(){
      layoutFrame=0;
      if(!root.isConnected){unpinGallery();lifecycle.abort();observer?.disconnect();return}
      if(innerWidth<900||root.dataset.sticky==='false'){
        unpinGallery();galleryStage.style.removeProperty('height');galleryColumn.style.removeProperty('min-height');return;
      }
      const column=galleryColumn.getBoundingClientRect();
      const style=getComputedStyle(root);
      const configuredGap=parseFloat(style.getPropertyValue('--jps-sticky-gap'));
      const gap=Number.isFinite(configuredGap)?configuredGap:24;
      const offset=Math.max(0,visibleHeaderBottom()+gap);
      const stageHeight=galleryStage.getBoundingClientRect().height;
      const extras=Math.max(0,galleryPanel.getBoundingClientRect().height-stageHeight);
      // Keep the image, thumbnails and caption visible even on short desktops.
      const available=Math.max(1,innerHeight-offset-20-extras);
      galleryStage.style.setProperty('height',Math.min(column.width,available)+'px','important');
      const height=galleryPanel.getBoundingClientRect().height;
      galleryColumn.style.minHeight=height+'px';
      const shouldPin=column.top<offset&&column.bottom>0&&column.height>height+1;
      if(!shouldPin){unpinGallery();return}
      if(!portal){
        portal=document.createElement('div');portal.className='jps-hero jps-sticky-portal';
        portal.style.cssText=root.style.cssText;
        document.body.append(portal);portal.append(galleryPanel);
      }
      const geometry=pinGeometry(column,height,offset);
      Object.assign(portal.style,{left:geometry.left+'px',width:geometry.width+'px',top:geometry.top+'px'});
    }
    function requestGalleryLayout(){if(!layoutFrame)layoutFrame=requestAnimationFrame(updateGalleryPosition)}
    function refreshLayout(){refreshThumbNavigation();requestGalleryLayout()}
    const observer=typeof ResizeObserver!=='undefined'?new ResizeObserver(refreshLayout):null;
    observer?.observe(root);observer?.observe(galleryPanel);
    window.addEventListener('scroll',requestGalleryLayout,{passive:true,signal:lifecycle.signal});
    window.addEventListener('resize',refreshLayout,{passive:true,signal:lifecycle.signal});
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){unpinGallery();observer?.disconnect();lifecycle.abort();cancelAnimationFrame(layoutFrame)}},{signal:lifecycle.signal});
    refreshLayout();
    const accordions=[...root.querySelectorAll('.jps-accordion')];
    let requested=accordions.find(d=>d.open)||null,accordionRevision=0,accordionQueue=Promise.resolve();
    accordions.forEach(d=>{if(d!==requested)d.open=false});
    async function animateAccordion(details,opening){
      const summary=details.querySelector('summary');
      const start=details.getBoundingClientRect().height;
      details.open=true;
      const end=opening?details.getBoundingClientRect().height:summary.getBoundingClientRect().height;
      if(matchMedia('(prefers-reduced-motion:reduce)').matches||!details.animate){details.open=opening;return}
      details.style.overflow='hidden';
      const motion=details.animate([{height:start+'px'},{height:end+'px'}],{duration:260,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'});
      try{await motion.finished}catch{}
      details.open=opening;motion.cancel();details.style.overflow='';
    }
    accordions.forEach(details=>details.querySelector('summary').addEventListener('click',event=>{
      event.preventDefault();requested=requested===details?null:details;
      const revision=++accordionRevision;
      accordionQueue=accordionQueue.then(async()=>{
        if(revision!==accordionRevision)return;
        const target=requested;
        for(const other of accordions){if(other.open&&other!==target)await animateAccordion(other,false)}
        if(revision!==accordionRevision)return;
        if(target&&!target.open)await animateAccordion(target,true);
      });
    }));
    update();
  }
  function init(scope=document){scope.querySelectorAll('.jps-hero[id^="JpsHero-"]').forEach(mount)}
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jps-oil-faq')) {

 customElements.define('jps-oil-faq', class extends HTMLElement {

  connectedCallback() {

   if (this.ready) return;

   this.ready = true;

   this.animations = new Map();

   this.items = Array.from(this.querySelectorAll('details'));

   this.items.forEach((item, index) => {

    item.open = index === 0 && this.hasAttribute('data-open-first');

    item.querySelector('summary').addEventListener('click', event => {

     event.preventDefault();

     const opening = !item.open || item.hasAttribute('data-closing');

     if (opening) this.items.forEach(other => { if (other !== item && other.open) this.toggleItem(other, false); });

     this.toggleItem(item, opening);

    });

   });

  }

  toggleItem(item, opening) {

   const start = item.getBoundingClientRect().height;

   const previous = this.animations.get(item);

   if (previous) previous.cancel();

   item.style.height = '';

   item.open = true;

   item.toggleAttribute('data-closing', !opening);

   const end = opening ? item.getBoundingClientRect().height : item.querySelector('summary').getBoundingClientRect().height;

   if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !item.animate) {

    item.open = opening;

    item.removeAttribute('data-closing');

    return;

   }

   const animation = item.animate([{height: start + 'px'}, {height: end + 'px'}], {duration: 280, easing: 'cubic-bezier(.22,1,.36,1)'});

   this.animations.set(item, animation);

   animation.onfinish = () => {

    item.open = opening;

    item.removeAttribute('data-closing');

    this.animations.delete(item);

   };

  }

  disconnectedCallback() {

   if (this.animations) this.animations.forEach(animation => animation.cancel());

  }

 });

}

  } catch(e) { console.error(e); }
})();
})();
